import { BRAND_ICON_ASSETS } from "../../lib/brand-icon";
import { useTheme } from "../../contexts/ThemeContext";

export function BrandIconSettings() {
  const { brandIconVariant, setBrandIconVariant } = useTheme();
  const isRegular = brandIconVariant === "regular";

  return (
    <section>
      <div className="mb-3 flex items-end justify-between gap-4">
        <div className="text-left">
          <h3 className="text-sm font-semibold text-[var(--fintheon-accent)]">
            Brand Icon
          </h3>
          <p className="mt-1 text-[10px] text-[var(--fintheon-text)]/38">
            Monetmorphism remains the built app icon.
          </p>
        </div>
        <IconSwitch
          enabled={isRegular}
          onToggle={() => setBrandIconVariant(isRegular ? "monet" : "regular")}
        />
      </div>
      <div className="grid grid-cols-2 gap-3 text-left">
        {(["monet", "regular"] as const).map((variant) => {
          const asset = BRAND_ICON_ASSETS[variant];
          const active = brandIconVariant === variant;
          return (
            <button
              key={variant}
              type="button"
              onClick={() => setBrandIconVariant(variant)}
              className={`flex items-center gap-3 rounded-md border px-3 py-2 text-left transition ${
                active
                  ? "border-[var(--fintheon-accent)]/48 text-[var(--fintheon-text)]"
                  : "border-[var(--fintheon-border)]/14 text-[var(--fintheon-text)]/55 hover:text-[var(--fintheon-text)]/78"
              }`}
            >
              <img
                src={asset.src}
                alt=""
                className="fintheon-app-icon-mask h-9 w-9"
              />
              <span className="min-w-0">
                <span className="block text-[12px] font-semibold">
                  {asset.label}
                </span>
                <span className="block truncate text-[10px] opacity-55">
                  {asset.detail}
                </span>
              </span>
            </button>
          );
        })}
      </div>
    </section>
  );
}

function IconSwitch({
  enabled,
  onToggle,
}: {
  enabled: boolean;
  onToggle: () => void;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={enabled}
      onClick={onToggle}
      className={`relative h-7 w-12 rounded-full border transition ${
        enabled
          ? "border-[var(--fintheon-accent)] bg-[var(--fintheon-accent)]"
          : "border-[var(--fintheon-border)]/18 bg-transparent"
      }`}
      title="Use regular logo chrome"
    >
      <span
        className={`absolute top-[3px] h-5 w-5 rounded-full transition ${
          enabled
            ? "left-[23px] bg-black"
            : "left-[3px] bg-[var(--fintheon-text)]/35"
        }`}
      />
    </button>
  );
}
